/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

export default [
  {
    title: "Papelería",
    description: "Amplio surtido de papeles y artículos para oficina y escuela.",
    items: [
      {
        icon: "description",
        name: "Hojas Bond y Reciclado",
        itemDescription: "Papel de alta calidad para impresión y uso diario en oficina.",
        route: "/pages/landing-pages/contact-us",
      },
      {
        icon: "auto_stories",
        name: "Papeles Especiales",
        itemDescription: "Papeles texturizados, fotográficos y de presentación premium.",
        route: "/pages/landing-pages/contact-us",
      },
      {
        icon: "menu_book",
        name: "Cuadernos y Libretas",
        itemDescription: "Variedad de formatos para escuela, oficina y uso personal.",
        route: "/pages/landing-pages/contact-us",
      },
      {
        icon: "folder",
        name: "Carpetas y Archivos",
        itemDescription: "Soluciones de organización y almacenamiento de documentos.",
        route: "/pages/landing-pages/contact-us",
      },
    ],
  },
  {
    title: "Tintas y Tóner",
    description: "Suministros de impresión de alta calidad para todas las marcas.",
    items: [
      {
        icon: "print",
        name: "Cartuchos de Tóner",
        itemDescription: "Tóner original y compatible para impresoras láser.",
        route: "/pages/landing-pages/contact-us",
      },
      {
        icon: "colorize",
        name: "Tintas Digitales",
        itemDescription: "Tintas de alta definición para impresión inkjet y plotters.",
        route: "/pages/landing-pages/contact-us",
      },
      {
        icon: "palette",
        name: "Tintas Serigráficas",
        itemDescription: "Tintas especiales para serigrafía y estampado textil.",
        route: "/pages/landing-pages/contact-us",
      },
    ],
  },
  {
    title: "Servicios de Impresión",
    description: "Soluciones profesionales para tus necesidades de comunicación visual.",
    items: [
      {
        icon: "devices",
        name: "Impresión Digital",
        itemDescription: "Impresión rápida y de alta calidad en cualquier cantidad.",
        route: "/pages/landing-pages/contact-us",
      },
      {
        icon: "precision_manufacturing",
        name: "Impresión Offset",
        itemDescription: "Producción en volumen con acabados profesionales.",
        route: "/pages/landing-pages/contact-us",
      },
      {
        icon: "panorama",
        name: "Gran Formato (Viniles)",
        itemDescription: "Lonas, viniles y señalización de gran impacto visual.",
        route: "/pages/landing-pages/contact-us",
      },
      {
        icon: "brush",
        name: "Personalización",
        itemDescription: "Productos promocionales y artículos personalizados.",
        route: "/pages/landing-pages/contact-us",
      },
    ],
  },
];
